'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _contextUtils = require('./contextUtils');

var _HateoasModelView = require('./HateoasModelView');

var _HateoasModelView2 = _interopRequireDefault(_HateoasModelView);

var _WithInitializedModel = require('./WithInitializedModel');

var _WithInitializedModel2 = _interopRequireDefault(_WithInitializedModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function validateModelPath(domainAndModelName) {
  if (!/[a-zA-Z0-9]+\.[a-zA-Z0-9]+/.test(domainAndModelName)) {
    throw new Error('wrong or unknown model name \'' + domainAndModelName + '\'');
  }
}

function getDomainNameAndModelName(domainAndModelName) {
  validateModelPath(domainAndModelName);

  var _domainAndModelName$s = domainAndModelName.split('.'),
      _domainAndModelName$s2 = _slicedToArray(_domainAndModelName$s, 2),
      domainName = _domainAndModelName$s2[0],
      modelName = _domainAndModelName$s2[1];

  return { domainName: domainName, modelName: modelName };
}

function getModelClassFromApplication(application, domainAndModelName) {
  _auroraJavascriptUtils.assert.object(application);
  _auroraJavascriptUtils.assert.string(domainAndModelName);

  var _getDomainNameAndMode = getDomainNameAndModelName(domainAndModelName),
      domainName = _getDomainNameAndMode.domainName,
      modelName = _getDomainNameAndMode.modelName;

  return application.getDomain(domainName).getModel(modelName);
}

var WithModel = function (_Component) {
  _inherits(WithModel, _Component);

  function WithModel() {
    _classCallCheck(this, WithModel);

    return _possibleConstructorReturn(this, (WithModel.__proto__ || Object.getPrototypeOf(WithModel)).apply(this, arguments));
  }

  _createClass(WithModel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          application = _props.application,
          model = _props.model,
          modelId = _props.modelId,
          loadingViewFactory = _props.loadingViewFactory,
          loadErrorViewFactory = _props.loadErrorViewFactory,
          children = _props.children;

      var modelClass = getModelClassFromApplication(application, model);

      return _react2.default.createElement(_HateoasModelView2.default, {
        modelClass: modelClass,
        modelId: modelId,
        view: _WithInitializedModel2.default,
        additionalProps: {
          loadingViewFactory: loadingViewFactory,
          loadErrorViewFactory: loadErrorViewFactory,
          children: children
        }
      });
    }
  }]);

  return WithModel;
}(_react.Component);

WithModel.propTypes = {
  model: _propTypes2.default.string.isRequired,
  modelId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  children: _propTypes2.default.func.isRequired,
  loadingViewFactory: _propTypes2.default.func,
  loadErrorViewFactory: _propTypes2.default.func
};
exports.default = (0, _contextUtils.passApplication)(WithModel);


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/WithModel.js
// module id = 1307
// module chunks = 118